import { render, staticRenderFns } from "./WideMartialData.vue?vue&type=template&id=53b3e81e&scoped=true&"
import script from "./WideMartialData.vue?vue&type=script&lang=js&"
export * from "./WideMartialData.vue?vue&type=script&lang=js&"
import style0 from "./WideMartialData.vue?vue&type=style&index=0&id=53b3e81e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3e81e",
  null
  
)

export default component.exports